import { ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef } from '@angular/core';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'spa-col-tpl',
  templateUrl: './spa-col-tpl.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpaColTplComponent {
  @Input() columnKey = '';
  @ContentChild(TemplateRef) template: TemplateRef<unknown> | undefined;
}
